<template lang="">
  <div class="app-create-new-ai-content__section">
    <div class="app-create-new-ai-content__section-header">
      <h4 class="app-create-new-ai-content__section-title">Describe Your Course</h4>
      <p class="app-create-new-ai-content__section-instructions">Give us a few more details. All fields are optional.</p>

      <app-error
        v-if="hasErrors"
        class="is--inline"
        v-bind="{ errors }" />
    </div>

    <form autocomplete="off" ref="inputForm">
      <div class="app-create-new-ai-content__section-body grid">
        <div class="col-12">
          <div class="input text">
            <label for="name">Who is this course for?</label>
            <input type="text" placeholder="Audience who must demonstrate the knowledge" name="input_audience" id="input_audience" :maxlength=editorMaxCharacterLimit_default v-model="publicationData.ai_preferences.input_audience">
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">Are there any particular types of activities or presentation methods you want to prioritize?</label>
            <input type="text" placeholder="Exploratory, knowledge checks" name="input_level" id="input_level" :maxlength=editorMaxCharacterLimit_default v-model="publicationData.ai_preferences.input_level">
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">What are your learning objectives?</label>
            <textarea rows="8" placeholder="Measurable, achievable, specific, and relevant outcomes" name="input_extra_prompt" id="input_extra_prompt" :maxlength=editorMaxCharacterLimit_extra_prompt v-model="publicationData.ai_preferences.input_extra_prompt"></textarea>
          </div>
          <p class="element-character-count">
            Character count: {{ getInputExtraPromptCharacterCount }}
          </p>
        </div>
      </div>
      <div class="app-create-new-ai-content__section-footer">
        <app-button theme="secondary" @click="$emit('previousScreen')">
          Back
        </app-button>
        <app-button theme="primary" @click=submitPublicationBasicData() class="" :disabled="disabledButton">
          {{ disabledButton ? 'Processing...' : 'Next: Select Your Golden Source' }}
        </app-button>
      </div>
    </form>
  </div>
</template>
<script>

export default {
  name: 'PublicaitonAiAppCourseDescription',
  props: {
    publication: {
      type: Object,
      required: true
    },
    subScreen: {
      type: String,
      required: true
    },
    editorMaxCharacterLimit_default: {
      type: Number,
      required: true
    },
    disabledButton: {
      type: Boolean,
      required: false,
      default: false
    },
    editorMaxCharacterLimit_extra_prompt: {
      type: Number,
      required: true
    },
    hasErrors: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    errorMessage: {
      type: String,
      required: false,
      default: null
    },
    saveTrigger: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      publicationData: this.publication
    }
  },
  methods: {
    submitPublicationBasicData(menuSwap = null) {
      const formData = new FormData(this.$refs.inputForm)
      const params = Object.fromEntries(formData.entries())
      this.$emit('submissionOfData', { publication: this.publicationData, subScreen: 'topics',params: params, entries: params, menuSwap})
    }
  },
  computed: {
    getInputExtraPromptCharacterCount() {
      const length = this.publicationData?.ai_preferences.input_extra_prompt?.length || 0
      return length + '/' + this.editorMaxCharacterLimit_extra_prompt
    }
  },
  watch: {
    saveTrigger(newVal) {
      if (newVal) {
        this.submitPublicationBasicData('menuSwap')
      }
    }
  }
}
</script>